import { ColDef, PostSortRowsParams, RowClickedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo, useRef, useState } from "react";
import { aggridHeaderClass, SmallTitleSpan, titleMRClass } from "src/components/common/common";
import useUiuxStore from "src/store/useUiuxStore";
import { CreateCellClickHandler, createCellCssClassRules, CreateCellDoubleClickHandler, CustomCellClickAction, CustomCellDoubleClickAction, GridCellConfig, InsertRowHandler, postSortHandler, RemoveRowHandler, useCellChangeHandler, useRowSelectionHandler } from "src/utils/grid/GridHandlerContent";
import { useGridSettingContent } from "src/utils/grid/GridSettingContent";
import { defaultColDef, getDefaultRowIndexColumnConfig, getRowStyleFlags, IndexParameterCell } from "src/utils/grid/gridStyleUtils";
import { useKSK2110_R01Store } from "./Store_KSK2110_R01";

import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import { GridCustomColumnDefs } from "src/utils/grid/GridCustomColumnDefs";
import { KSK2110_R01LotDto, KSK2110_R01InspectDto, KSK2110_R01DetailDto } from "./Dto_KSK2110_R01";

import Grid_Excel from "src/components/common/gridWrapper/Grid_Excel";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";

// 범용 훅 임포트
import { useDetailTableEvents } from "src/hooks/detail-table/useDetailTableEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { getAllWorkPlaces } from "src/apis/workPlaceApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { getAllWarehouses } from "src/apis/warehouseApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { showWarning } from "src/utils/toast/toastUtil";
import { useDescText } from "src/hooks/useDescText";
import { DESC_FLD } from "src/utils/descLanguage/descLanguageUtil";

const COLUMN_STATE_KEY = 'KSK2110_R01-lot-grid-column-state';

const GRID_CELL_CONFIG: GridCellConfig = {
	disabledCells: ['lotNo'],
	insertedDisabledCells: [''],
	commonDisabledCells: [''],
	
	pointerCells: ['lotQty'],
	insertedPointerCells: [''],
	commonPointerCells: [''],
	
	alignLeftCells: [''],
};

interface Props {
	lotGridRef: React.RefObject<AgGridReact<KSK2110_R01LotDto> | null>;
	defaultKSK2110_R01LotRow: KSK2110_R01LotDto;
}

export const LotTable_KSK2110_R01 = (props: Props) => {

	const { lotGridRef, defaultKSK2110_R01LotRow } = props;

	const { 
			KSK2110_R01Filter, setKSK2110_R01Filter,
			KSK2110_R01LotList, setKSK2110_R01LotList, 
			editKSK2110_R01, setEditKSK2110_R01,
			selectedKSK2110_R01LotList, setSelectedKSK2110_R01LotList, removeSelectedKSK2110_R01LotList, addSelectedKSK2110_R01LotList, initSelectedKSK2110_R01LotList,
			deletedKSK2110_R01LotList, setDeletedKSK2110_R01LotList, addDeletedKSK2110_R01LotList, removeDeletedKSK2110_R01LotList,
			insertKSK2110_R01LotList, updateKSK2110_R01LotList, removeKSK2110_R01LotList,
			lotColumnState, setLotColumnState,
			originalKSK2110_R01LotList, setOriginalKSK2110_R01LotList,
			modalVisible, setModalVisible,
		} = useKSK2110_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { itemStatusList } = useCommonCodeStore();
	const { renderDescText } = useDescText();
	const [clickable, setClickable] = useState(true);

	//const gridRef = useRef<AgGridReact>(null);
	const gridWrapperRef = useRef<HTMLDivElement>(null); // 1. div를 위한 ref 생성

	const {
		getRowId,
		createRowClassRules,
		createCellClassRules,
		paddedGridData,
		renderIndexCell,
	} = useGridSettingContent({
		gridRef: lotGridRef,
		key: 'valueIndex',
		gridData: KSK2110_R01LotList,
		defaultGridData: defaultKSK2110_R01LotRow,
		selectedRow: selectedKSK2110_R01LotList,
		originalGridData: originalKSK2110_R01LotList,
		updateRow: (index: number, data: any) => updateKSK2110_R01LotList(index, data),
	});
	
	

	const headerNames: Record<string, string> = {
		rowIndex: "",
		lotQty: '생산량',
		lotCd: 'LOT No',
	}

	const {
		disabledInsertedColumns, disabledColumns,
		pointerInsertedColumns, pointerColumns,
		alignLeftColumns,
	} = createCellCssClassRules(GRID_CELL_CONFIG);

	const gridDefaultColDef = useMemo(() => {
        const baseRules = createCellClassRules<KSK2110_R01LotDto>({
            idKey: 'valueIndex',
            selectedList: selectedKSK2110_R01LotList,
            deletedList: deletedKSK2110_R01LotList,
            disabledInsertedColumns,	disabledColumns,
            pointerInsertedColumns,		pointerColumns,
            alignLeftColumns,
        });

        return { ...defaultColDef, cellClassRules: { ...baseRules, }}; 
	}, [
        selectedKSK2110_R01LotList, deletedKSK2110_R01LotList,
        disabledInsertedColumns, disabledColumns,         
        pointerInsertedColumns, pointerColumns,
		alignLeftColumns,
    ]);

	const baseColumnDefs: ColDef<KSK2110_R01LotDto>[] = useMemo(() => [
		...getDefaultRowIndexColumnConfig(
			// (params: KSK2110_R01InspectDto) => renderIndexCell(
			// 	params, 
			// 	(innerParams: KSK2110_R01LotDto) => getRowStyleFlags (
			// 		innerParams,
			// 		{
			// 			deletedList: deletedKSK2110_R01LotList,
			// 			selectedList: selectedKSK2110_R01LotList,
			// 			dataList: KSK2110_R01LotList
			// 		}),
			// 	(rowIndex: number, e: React.MouseEvent) => {},
			// 	(rowData) => RemoveRowHandler( 
			// 		lotGridRef,
			// 		KSK2110_R01LotList, 
			// 		rowData,  // rowData는 renderIndexCell에서 Dto 형식으로 선언함
			// 		setClickable, 
			// 		removeKSK2110_R01LotList, 
			// 		(valueIndex) => addDeletedKSK2110_R01LotList([valueIndex.toString()])
			// 	),
			// )
		),
		{
			headerName: '생산량', colId: 'lotQty', field: 'lotQty', width: 80,
			editable: (params: any) => params.data.inserted === true,
			pasteable: true,
			valueFormatter: (params: any) =>
				params.value != null ? params.value.toLocaleString() : '',
		},
        {
            headerName: 'LOT No', colId: 'lotNo', field: 'lotNo', width: 130,
			editable: false,
		},
		// ...IndexParameterCell(),
	], [deletedKSK2110_R01LotList, KSK2110_R01LotList]);

	const columnDefs: ColDef<KSK2110_R01LotDto>[] = useMemo(() => {
		if (lotColumnState === null) {
			return baseColumnDefs;
		}
		
		return GridCustomColumnDefs<KSK2110_R01LotDto>({
			baseColumnDefs,
			columnState: lotColumnState,
			headerNames,
			fallbackHeaderClass: aggridHeaderClass
		});
	}, [baseColumnDefs, lotColumnState, headerNames]);

	
	const handleCellChange = useCellChangeHandler({
		dataList: KSK2110_R01LotList,
		originalDataList: originalKSK2110_R01LotList,
		updateRow: updateKSK2110_R01LotList,
		customBeforeUpdate: (updatedData, field, value) => {
			return updatedData;
		},
		customAfterUpdate: (updatedData, field, value) => {
			return updatedData;
		},
	});
	

	const handleRowClick = useRowSelectionHandler({
		dataList: KSK2110_R01LotList,
		idKey: 'valueIndex',
		selectedList: selectedKSK2110_R01LotList,
		deletedList: deletedKSK2110_R01LotList,
		addSelected: addSelectedKSK2110_R01LotList,
		removeSelected: removeSelectedKSK2110_R01LotList,
		clickable, setClickable
	});

	const commonInputColumns = ['lotNo', 'lotQty', 'remark', ];

	// 범용 이벤트 훅을 위한 설정
	const defaultEditableColumns = ['lotNo', 'lotQty', 'remark'];


	// 범용 이벤트 훅 사용 (코드 검색 없이) - 방향키 이동 기능 유지
	/**
	 * 기본 상세 테이블 이벤트 핸들러 훅
	 * 
	 * 주요 기능:
	 * - 키다운 네비게이션 (방향키 이동)
	 * - 셀 클릭/키다운 이벤트 처리
	 * 
	 * @param detailList - 상세 데이터 목록
	 * @param editableColumns - 편집 가능한 컬럼 목록
	 */
	const cellEventHandlers = useDetailTableEvents({
		detailList: KSK2110_R01LotList as any,
		editableColumns: defaultEditableColumns,
		keyDownConfig: {
			enableArrowNavigation: true,
		}
	});
	
	const cellClickActions: CustomCellClickAction<KSK2110_R01LotDto>[] = useMemo(() => [
		{
			validate: (field, data) => {
				return commonInputColumns.includes(field);
			},
			//aggrid 기본 편집 기능
			action: (e) => { e.api.startEditingCell({ rowIndex: e.rowIndex!, colKey: e.colDef.field! }); }
		},
	], []);
	const handleCellClick = CreateCellClickHandler(KSK2110_R01LotList, 'valueIndex', cellClickActions);

	//더블클릭 액션 없음
	const cellDoubleClickActions: CustomCellDoubleClickAction<KSK2110_R01LotDto>[] = useMemo(() => [
	], [editKSK2110_R01?.itemCd]);
	const handleCellDoubleClick = CreateCellDoubleClickHandler(KSK2110_R01LotList, 'valueIndex', cellDoubleClickActions);

	const handleRemoveLastRow = useCallback(() => {
		if (KSK2110_R01LotList.length > 1) {
			const lastItem = KSK2110_R01LotList[KSK2110_R01LotList.length - 1];
			removeKSK2110_R01LotList(lastItem.valueIndex);
		}else{
			showWarning('마지막 행은 삭제할 수 없습니다.');
		}
	}, [KSK2110_R01LotList, removeKSK2110_R01LotList]);


	const handlePostSort = useCallback((params: PostSortRowsParams<KSK2110_R01LotDto>) => {
		postSortHandler(params, KSK2110_R01LotList, originalKSK2110_R01LotList, setKSK2110_R01LotList);
	}, [KSK2110_R01LotList, originalKSK2110_R01LotList, ]);

	const pinnedBottomRowData = useMemo(() => {
		// 삭제된 행은 제외하고 수량 합계 계산
		const totalQty : number = KSK2110_R01LotList
			.reduce((sum, item) => sum + (deletedKSK2110_R01LotList.includes(item.valueIndex.toString()) ? 0 : Number(item.lotQty) || 0), 0);

		return [{
			lotNo: KSK2110_R01LotList.length.toLocaleString() + "건",
			lotQty: totalQty,
		}];	  
	}, [KSK2110_R01LotList, deletedKSK2110_R01LotList,]);

	return (
		<>
			<div className="flex flex-1 gap-[4px] h-full min-h-full">
				<GridContextWrapper<KSK2110_R01LotDto>
					gridWrapperRef={gridWrapperRef}
					gridRef={lotGridRef}
					paddedGridData={paddedGridData}
					setPaddedGridData={setKSK2110_R01LotList}
					initSelected={initSelectedKSK2110_R01LotList}
					defaultRowData={defaultKSK2110_R01LotRow}
					baseColumnDefs={columnDefs}	
					setColumnState={setLotColumnState}
					localStorageKey={COLUMN_STATE_KEY}
					menuItems={undefined}
				>
					
					<SmallTitleSpan>
						생산 Lot
						<div className="flex items-center gap-[8px] ml-auto">
							<button 
								className={`relative w-[100px] bg-blue-dark text-white text-[18px] py-[1px] rounded-[4px] h-[30px]`}
								onClick={() => insertKSK2110_R01LotList([{ ...defaultKSK2110_R01LotRow }])}
								>
								{renderDescText(DESC_FLD.ROW_ADD, "행 +")}
							</button>
							<button 
								className={`relative w-[100px] bg-blue-dark text-white text-[18px] py-[1px] rounded-[4px] h-[30px]`}
								onClick={handleRemoveLastRow}
								>
								{renderDescText(DESC_FLD.ROW_DELETE, "행 -")}
							</button>
							<button 
								className={`relative w-[100px] bg-blue-dark text-white text-[18px] py-[1px] rounded-[4px] h-[30px]`}
								onClick={() => setModalVisible(!modalVisible)}
								>
								불량내역
							</button>
						</div>
					</SmallTitleSpan>	
					
					<Grid_Excel<KSK2110_R01LotDto>
						ref={lotGridRef}
						rowData={paddedGridData}	getRowId={getRowId} // +- 버튼 테이블 getRowId는 valueIndex로 고정
						columnDefs={columnDefs}		
						defaultColDef={gridDefaultColDef}

						rowClassRules={createRowClassRules<KSK2110_R01LotDto>({
							idKey: 'valueIndex',
							selectedList: selectedKSK2110_R01LotList,
							deletedList: deletedKSK2110_R01LotList
						})}

						onRowClicked={handleRowClick}
						onCellClicked={handleCellClick}
						onCellDoubleClicked={handleCellDoubleClick}
						onCellKeyDown={cellEventHandlers.handleCellKeyDown}
						onCellValueChanged={handleCellChange}
						pinnedBottomRowData={pinnedBottomRowData}
						

						onPostSortRows={handlePostSort} //onSortChanged 삭제, 커스텀 정렬 기능추가 
						// Grid_Select에 공통 로직 처리를 위한 props 전달
						columnStateKey={COLUMN_STATE_KEY}			//컬럼 상태 키(로컬스토리지)	
						setColumnState={setLotColumnState}		//컬럼 상태 저장
					/>
				</GridContextWrapper>
			</div>
		</>
	)
}	